import React from 'react';
import { Tooltip, IconButton, Typography, Box, ClickAwayListener } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

/**
 * Ícono "?" junto a un campo o título, con explicación y ejemplo opcional.
 * Funciona con hover (escritorio) y con toque (móvil).
 */
const InfoTip: React.FC<{ texto: React.ReactNode; ejemplo?: string; size?: number }> = ({ texto, ejemplo, size = 18 }) => {
  const [abierto, setAbierto] = React.useState(false);
  return (
    <ClickAwayListener onClickAway={() => setAbierto(false)}>
      <Box component="span" sx={{ display: 'inline-flex', verticalAlign: 'middle' }}>
        <Tooltip
          arrow
          open={abierto}
          onOpen={() => setAbierto(true)}
          onClose={() => setAbierto(false)}
          title={
            <Box sx={{ p: 0.5, maxWidth: 300 }}>
              <Typography variant="body2" sx={{ lineHeight: 1.45 }}>{texto}</Typography>
              {ejemplo && (
                <Box sx={{ mt: 1, p: 1, borderRadius: 1, bgcolor: 'rgba(255,255,255,0.12)' }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, display: 'block' }}>Ejemplo</Typography>
                  <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>{ejemplo}</Typography>
                </Box>
              )}
            </Box>
          }
        >
          <IconButton size="small" onClick={() => setAbierto((v) => !v)} sx={{ p: 0.3, ml: 0.3, color: 'text.secondary' }} aria-label="Más información">
            <HelpOutline sx={{ fontSize: size }} />
          </IconButton>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default InfoTip;
